<template>
    <ul class="headlines">
        <li
        v-for="(item, index) in headlines"
        :key="index">
            <el-link
            :href="item.url"
            target="_blank"
            :underline="false">{{item.title}}</el-link>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'Headlines',
    props: ['headlines']
}
</script>

<style scoped>
.headlines {
    max-width: 1100px;
    margin: 20px auto;
}

.headlines li {
    text-align: center;
}

.headlines .el-link {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    line-height: 40px;
}

.headlines .el-link:hover {
    color: dodgerblue;
}

@media(max-width: 1100px) {
    .headlines {
        width: 90%;
        margin: 20px auto 0 auto;
    }

    .headlines .el-link {
        font-size: 16px;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
    }
}
</style>
